'use client';

import { Alert } from '@mui/material';
import * as React from 'react';
import { ReactElement, ReactNode } from 'react';
import { ErrorBoundary } from 'react-error-boundary';
import { ErrorBoundaryProps } from 'react-error-boundary/dist/declarations/src/types';
import { useTranslation } from 'react-i18next';

type PropsType = Omit<ErrorBoundaryProps, 'fallback'> &
  Partial<Pick<ErrorBoundaryProps, 'fallback'>> & {
    alertMessage?: ReactNode;
  };

export const PortalErrorBoundary = (props: PropsType) => {
  const { children, fallback, alertMessage } = props;

  const { t } = useTranslation();

  const fallbackContent = (): ReactElement => {
    if (!!fallback) {
      return fallback;
    }

    return (
      <Alert severity={'error'}>{alertMessage ?? t('laGeneralError')}</Alert>
    );
  };

  return <ErrorBoundary fallback={fallbackContent()}>{children}</ErrorBoundary>;
};
